import React from 'react';
import styled from '@emotion/styled';

type FooterImageProps = {
  imageUrl?: string;
  className?: string;
};

const FooterImage = ({ imageUrl, className }: FooterImageProps): JSX.Element | null => {
  const Image = styled.img`
    width: 100%;
  `;

  if (!imageUrl) return null;

  return (
    <div className={className}>
      <Image src={imageUrl} />
    </div>
  );
};

export default FooterImage;
